// extracted by mini-css-extract-plugin
export default {"leave":"mmB24","leaveActive":"_2RF7y"};